import React, { useMemo } from 'react';
import styles from '../StudentImages.module.sass';
import PreviewImage from '../../../../../PreviewImage';

export default function TopHeavyMarkup({ studentImages, background }) {
  const offset = useMemo(() => {
    const temp = Math.ceil(studentImages.length / 2);

    if (studentImages.length % 2 === 1) return temp;

    return temp + 1;
  }, [studentImages.length]);

  return (
    <div className={`${styles.imageContainer} ${styles.limitImageWidth}`}>
      <div className={styles.imageRow}>
        {studentImages.slice(0, offset).map((image) => (
          <div className={styles.imageSection}>
            <PreviewImage
              foregroundUrl={image.watermarkUrl}
              backgroundUrl={background.imageUrl}
              classes={styles.image}
            />
            <p className={styles.season}>
              {image.folder.match(/\d/g).join('')}
            </p>
          </div>
        ))}
      </div>
      <div className={styles.imageRow}>
        {studentImages.slice(offset, studentImages.length).map((image) => (
          <div className={styles.imageSection}>
            <PreviewImage
              foregroundUrl={image.watermarkUrl}
              backgroundUrl={background.imageUrl}
              classes={styles.image}
            />
            <p className={styles.season}>
              {image.folder.match(/\d/g).join('')}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
